import React from 'react';
import styled from 'styled-components';

// Components
import EventCardsPaged from '../../_molecules/EventCardsPaged/index.js';
import ArrowRightIcon from '@icons/ArrowRightIcon';
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge, DivWithShadowMediumUp, H4, LinkSmall } from '@styled';

// Helpers
import useRegisteredEvents from '../../../hooks/useRegisteredEvents';
import useSavedEvents from '@hooks/favorites/useSavedEvents';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';

const CardContainerOuter = styled(DivWithShadowMediumUp)`
    @media ${mediaQueries.md} {
        padding: 32px 32px 19px 32px;
    }
`;

const MyUpcomingEvents = () => {
    const { registeredEvents } = useRegisteredEvents();
    const { data: savedEvents } = useSavedEvents();

    if (!registeredEvents || !savedEvents) {
        return <LoadingArea />;
    }

    return (
        <div>
            <H4 className="mb-1.5rem">My Upcoming Events</H4>

            <CardContainerOuter>
                {registeredEvents.length > 0 && (
                    <BodyLarge className="mb-1.875rem">
                        You’ve already registered for these events — build out your agenda and start scheduling meetings
                        with other ICSC members.
                    </BodyLarge>
                )}

                {registeredEvents.length === 0 && (
                    <BodyLarge className="mb-1.875rem d-md-flex justify-content-between mb-2rem">
                        You are not registered for any events. See your recommended events below.
                        <LinkSmall
                            href="/search?type=events"
                            className="align-items-center cursor-pointer d-flex text-primary"
                        >
                            <span className="mr-0.5rem">See All Upcoming Events</span>
                            <ArrowRightIcon color={colors.primary} />
                        </LinkSmall>
                    </BodyLarge>
                )}

                <EventCardsPaged events={registeredEvents} />
            </CardContainerOuter>
        </div>
    );
};

MyUpcomingEvents.propTypes = {
    //
};

export default MyUpcomingEvents;
